export function showActionModal(text) {
    const existing = document.querySelector('.blog-action-info-modal');
    if (existing) {
        existing.remove();
    }
    const modal = document.createElement('div');
    modal.className = 'blog-action-info-modal';
    modal.innerHTML = `<span class="blog-action-info-modal__text">${text}</span>`;
    document.body.appendChild(modal);

    requestAnimationFrame(() => {
        modal.classList.add('blog-action-info-modal_active');
    });

    setTimeout(() => {
        modal.classList.remove('blog-action-info-modal_active');

        setTimeout(() => {
            modal.remove();
        }, 300);
    }, 2000);
}
